// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import App from "./App";

import VueCookies from "vue-cookies";
import VueResource from "vue-resource";
import router from "./router";
import ElementUI from "element-ui";
import VueI18n from "vue-i18n";
import { messages } from "./components/common/i18n";
import Plugin from "v-fit-columns";
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
import "./assets/css/theme-green/index.css"; // 浅绿色主题
import "./assets/css/icon.css";
import "./components/common/directives";
import locale from "element-ui/lib/locale/lang/en";
import axios from "axios";
import qs from "qs";
import cookieService from "./service/cookie-service";
import fileService from "./service/file-service";
import store from "./store";
import storage from "./store/storage";
import Util from "./utils";
import CustomUtil from "./utils/custom-util";
import filter from "./filter";
import dateTime from "vue-date-time-m";

axios.defaults.baseURL = "/api";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;
Vue.config.productionTip = false;
Vue.prototype.axios = axios; //全局注册，使用方法为:this.$axios
Vue.prototype.qs = qs; //全局注册，使用方法为:this.qs
Vue.prototype.$axios = axios;

Vue.component("data-time", dateTime);
Vue.use(Plugin);
Vue.use(VueI18n);
Vue.use(ElementUI)
const i18n = new VueI18n({
  locale: "zh",
  messages
});
Vue.use(VueCookies);

Vue.use(VueResource);
Vue.http.options.emulateJSON = true;
//Vue.http.options.root = process.env.BUSI_HOST;
Vue.http.interceptors.push((request, next) => {
  request.credentials = true;
  next();
});
Vue.use(Util);
Vue.use(cookieService);
// Vue.use(ssoService);
Vue.use(fileService);

let beforeUnloadTime = 0;
let gapTime = 0;

// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  if (to.params.retitle) {
    to.meta.title = to.params.retitle;
  }
  document.title = `${to.meta.title} | 后台管理系统`;
  if (to.query.logintype == "nologin") {
    next();
  } else {
    if (to.path === "/login") {
      next();
    } else {
      const isLogin = storage.getO("isLogin");
      const token = storage.getO("token");
      const bearer = "bearer " + token;
      const notChina = storage.getO("notChina");
      if (notChina) {
        Vue.use(ElementUI, {
          locale
        });
      } else {
        Vue.use(ElementUI, {
          size: "small"
        });
      }
      axios.defaults.headers.post["Authorization"] = bearer;
      if (!isLogin) {
        next("/login");
      } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf("MSIE") > -1 && to.path === "/editor") {
          Vue.prototype.$alert(
            "vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看",
            "浏览器不兼容通知",
            {
              confirmButtonText: "确定"
            }
          );
        } else {
          next();
        }
      }
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>",
  store,
  methods: {
    addCustomUtil() {
      for (let method in CustomUtil) {
        Vue.prototype[method] = CustomUtil[method].call(this, []);
      }
    },
    addCustomService() {},
    addFilter() {
      filter.install();
    },
    //添加beforeunload监听事件
    createBeforeunloadHandler() {
      window.addEventListener("beforeunload", this.beforeunloadHandler, false);
      window.addEventListener("unload", this.unloadHandler, false);
    },
    //移除beforeunload事件
    destroyedBeforeunloadHandler() {
      window.removeEventListener(
        "beforeunload",
        this.beforeunloadHandler,
        false
      );
      window.removeEventListener("unload", this.beforeunloadHandler, false);
    },
    //beforeunload监听事件
    beforeunloadHandler(e) {
      beforeUnloadTime = new Date().getTime();
      console.log("beforeunloadHandler");
    },
    unloadHandler(e) {
      gapTime = new Date().getTime - beforeUnloadTime;
      console.log("unloadHandler");
    }
  },
  mounted() {
    this.createBeforeunloadHandler();
    this.addCustomUtil();
    this.addCustomService();
    this.addFilter();
  },
  beforeDestroy() {
    //在 beforeDestroy 钩子移除beforeunload事件
    this.destroyedBeforeunloadHandler();
  }
});



// WEBPACK FOOTER //
// ./src/main.js